import { Translate2 } from 'common'
import { SortOrderItem } from '../../../../src/store/models/SearchModels'

export function getSortOptions(): SortOrderItem[] {
  return [
    {
      label: Translate2('recommended'),
      property: 'Recommended',
      dir: 'desc',
    },
    {
      label: Translate2('availability'),
      property: 'Availability',
      dir: 'desc',
    },
    { label: Translate2('costLowHigh'), property: 'Cost', dir: 'asc' },
    { label: Translate2('costHighLow'), property: 'Cost', dir: 'desc' },
    { label: Translate2('listLowHigh'), property: 'List', dir: 'asc' },
    { label: Translate2('listHighLow'), property: 'List', dir: 'desc' },
    { label: Translate2('brandAZ'), property: 'Brand', dir: 'asc' },
    { label: Translate2('brandZA'), property: 'Brand', dir: 'desc' },
    {
      label: Translate2('partNumberAZ'),
      property: 'Part Number',
      dir: 'asc',
    },
    {
      label: Translate2('partNumberZA'),
      property: 'Part Number',
      dir: 'desc',
    },
    {
      label: Translate2('partDescriptionAZ'),
      property: 'Part Description',
      dir: 'asc',
    },
    {
      label: Translate2('partDescriptionZA'),
      property: 'Part Description',
      dir: 'desc',
    },
  ]
}
